/* eslint-disable react-refresh/only-export-components */
import { createContext, useContext, useState, useCallback, type ReactNode } from "react";
import Toast, { type ToastType } from "@/components/Toast";

interface ToastOptions {
  type: ToastType;
  title: string;
  message: string;
  autoHide: boolean;
}

interface ToastContextValue {
  showToast: (options: ToastOptions) => void;
}

const ToastContext = createContext<ToastContextValue | null>(null);

export const ToastProvider = ({ children }: { children: ReactNode }) => {
  const [toast, setToast] = useState<ToastOptions | null>(null);

  const showToast = useCallback((options: ToastOptions) => {
    setToast(options);
  }, []);

  const handleClose = useCallback(() => {
    setToast(null);
  }, []);

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      <div className="fixed top-4 right-4 z-50 pointer-events-none">
        {toast && (
          <Toast
            type={toast.type}
            title={toast.title}
            message={toast.message}
            autoHide={toast.autoHide}
            onClose={handleClose}
          />
        )}
      </div>
    </ToastContext.Provider>
  );
};

export const useAppToast = (): ToastContextValue => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error("useAppToast must be used within a ToastProvider");
  }
  return context;
};
